var _g, _g2, _g3, _g4, _path, _g5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTop1Big = function SvgTop1Big(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top1_big_svg__psukvm1tka)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.765 6.977h-.13C3.418 6.977 0 6.757 0 10.898c0 4.14 3.419 11.077 7.634 11.077h.131c1.495 0 2.704-1.189 2.704-2.657V9.633c0-1.465-1.21-2.656-2.704-2.656zm32.6 0h-.13c-1.495 0-2.704 1.188-2.704 2.656v9.682c0 1.468 1.21 2.656 2.704 2.656h.13c4.216 0 7.635-6.935 7.635-11.076 0-4.138-3.416-3.918-7.634-3.918z",
    fill: "#FFE479"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top1_big_svg__ec6eqn6v5b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE479",
    d: "M21.332 31.975h6v12h-6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top1_big_svg__7puwby0b4c)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.333,
    y: 40.975,
    width: 30,
    height: 6,
    rx: 3,
    fill: "#FFE479"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top1_big_svg__w1e32zdked)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.443 0H13.38C9.856 0 7 2.602 7 5.812v13.144c0 8.76 7.795 15.863 17.41 15.863 9.614 0 17.41-7.103 17.41-15.863V5.81c0-3.208-2.856-5.81-6.377-5.81z",
    fill: "url(#Top1_big_svg__nn29py6l9e)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Top1_big_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.443 0H13.38C9.856 0 7 2.602 7 5.812v13.144c0 8.76 7.795 15.863 17.41 15.863 9.614 0 17.41-7.103 17.41-15.863V5.81c0-3.208-2.856-5.81-6.377-5.81z",
    fill: "url(#Top1_big_svg__kxljqayyaf)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Top1_big_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#Top1_big_svg__4shc155zth)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.374 28.235C8.47 29.895 8.912 10.1 11.12-.005L31-1.668c-2.485 5.814-7.29 19.934-6.626 29.902z",
    fill: "#FFE65A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top1_big_svg__p0b3qkow1i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.681 28.588c15.542 3.76 17.734-15.92 16.888-26.23L35.086-1.928c1.69 6.093 4.576 20.727 2.595 30.517z",
    fill: "#FFE65A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top1_big_svg__923b0twh2j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.475 31.938c-3.177 15.671 16.57 17.129 26.84 15.899l3.56-19.629c-6.026 1.916-20.542 5.345-30.4 3.73z",
    fill: "#F69800"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top1_big_svg__svdxjrmokk)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.914 26a1 1 0 001-1V7a1 1 0 00-1-1h-3.077a1 1 0 00-.655.245l-4.338 3.77a1 1 0 00-.344.754v3.679a.3.3 0 00.497.226l4.467-3.881V25a1 1 0 001 1h2.45z",
    fill: "url(#Top1_big_svg__7yzdfkgusl)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Top1_big_svg__psukvm1tka",
    x: 0,
    y: 6.975,
    width: 48,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top1_big_svg__ec6eqn6v5b",
    x: 21.332,
    y: 31.975,
    width: 6,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top1_big_svg__7puwby0b4c",
    x: 9.333,
    y: 40.975,
    width: 30,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top1_big_svg__w1e32zdked",
    x: 4,
    y: -2,
    width: 37.819,
    height: 36.819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.976471 0 0 0 0 0.643137 0 0 0 0 0.0431373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277880"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_4982_277880",
    result: "effect2_innerShadow_4982_277880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top1_big_svg__4shc155zth",
    x: -1,
    y: -12.667,
    width: 43,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_4982_277880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top1_big_svg__p0b3qkow1i",
    x: 24.086,
    y: -12.929,
    width: 41.638,
    height: 52.988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_4982_277880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top1_big_svg__923b0twh2j",
    x: -0.867,
    y: 17.208,
    width: 52.741,
    height: 41.966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_4982_277880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top1_big_svg__svdxjrmokk",
    x: 16.5,
    y: 5,
    width: 13.414,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.945833 0 0 0 0 0.583264 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4982_277880"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4982_277880",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Top1_big_svg__nn29py6l9e",
    x1: 33.944,
    y1: 17.333,
    x2: 11.944,
    y2: 17.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Top1_big_svg__kxljqayyaf",
    x1: 33.944,
    y1: 17.333,
    x2: 11.944,
    y2: 17.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Top1_big_svg__7yzdfkgusl",
    x1: 23.207,
    y1: 6,
    x2: 23.207,
    y2: 25.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF3C4"
  })))));
};

export default SvgTop1Big;